import { useQuery } from "@tanstack/react-query";

import { usePortalUserStore } from "@/app/stores";
import { env } from "@/config/env";
import { isInactiveSubscription } from "@/features/consultations/utils";
import { testosteroneQueriesStore } from "@/features/testosterone-therapy/api";
import {
  TestosteroneLabsNotificationModal,
  TestosteroneTherapyStepper,
} from "@/features/testosterone-therapy/sections";
import {
  SUBSCRIPTION_STATUS,
  TESTOSTERONE_STEP_STATUS,
  TESTOSTERONE_STEP_TYPES,
} from "@/shared/domains";
import {
  CheckInBanner,
  HomeTabs,
  InactiveSubscriptionAlert,
  PendingIntakeFormAlert,
  ReferralProgramSection,
  SomeSubscriptionsIssueAlert,
} from "./components";

const referralEnabled = env.VITE_REFERRAL_ENABLED;

export const HomeContent = () => {
  const subscriptions =
    usePortalUserStore((state) => state.portalUser?.subscriptions) ?? [];

  const activeSubscriptionsWithIncompletedIntakeForm = usePortalUserStore(
    (state) => state.subscriptionsWithPendingIntakeForm,
  );

  const { data: afterLabCompletedStep, isSuccess } = useQuery({
    ...testosteroneQueriesStore.steps,
    select: (data) =>
      data.find(
        (step) =>
          step.type === TESTOSTERONE_STEP_TYPES.PROVIDER_CONSULTATION &&
          step.status === TESTOSTERONE_STEP_STATUS.IN_PROGRESS,
      ),
  });

  if (!subscriptions.length) {
    return (
      <InactiveSubscriptionAlert
        subscriptionStatus={SUBSCRIPTION_STATUS.CANCELLED}
      />
    );
  }

  const showPaymentFailedAlert = subscriptions.every((subscription) =>
    isInactiveSubscription(subscription.status),
  );

  if (showPaymentFailedAlert) {
    return (
      <InactiveSubscriptionAlert
        subscriptionStatus={SUBSCRIPTION_STATUS.PAYMENT_FAILED}
      />
    );
  }

  const showSomeSubscriptionsIssueAlert = subscriptions.some((subscription) =>
    isInactiveSubscription(subscription.status),
  );

  const pendingFollowUpSubscription = subscriptions.find(
    ({ hasPendingFollowUp }) => hasPendingFollowUp,
  );

  return (
    <div className="flex flex-col gap-6">
      {pendingFollowUpSubscription && (
        <CheckInBanner
          productId={pendingFollowUpSubscription.product.id}
          subscriptionId={pendingFollowUpSubscription.id}
        />
      )}

      {showSomeSubscriptionsIssueAlert && <SomeSubscriptionsIssueAlert />}

      <PendingIntakeFormAlert />

      <TestosteroneTherapyStepper />

      {referralEnabled && <ReferralProgramSection />}

      {isSuccess && afterLabCompletedStep && (
        <TestosteroneLabsNotificationModal step={afterLabCompletedStep} />
      )}

      {!activeSubscriptionsWithIncompletedIntakeForm?.length && <HomeTabs />}
    </div>
  );
};
